import React, { createContext, useContext, useMemo } from 'react'

import { DEFAULT_CURRENCY } from 'config'
import PropTypes from 'prop-types'

import {
  AUTHORIZATION_COOKIE_KEY,
  LOGIN_SESSION_DATA_LOCAL_STORAGE_KEY,
} from '@/blocks/Auth/definitions'
import { useAuthCookieManager } from '@/blocks/Auth/hooks'

import SocketProvider from './SocketContext'

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const { getAuthFromCookie } = useAuthCookieManager()
  const {
    token,
    temporary,
    isDocToken: isDocTokenSession,
    isAutoShare,
    estimateType,
    browserType,
  } = getAuthFromCookie(AUTHORIZATION_COOKIE_KEY)

  const user = JSON.parse(
    localStorage.getItem(LOGIN_SESSION_DATA_LOCAL_STORAGE_KEY),
  )
  const {
    hasClickIns: canRunAiInspection = false,
    currency: userCurrency = DEFAULT_CURRENCY,
    country,
    driverSide,
  } = user?.settings || {}

  const userValues = useMemo(() => {
    return {
      isLoggedIn: !!token && !temporary,
      token,
      isAutoShare,
      estimateType,
      browserType,
      isLoading: false,
      isDocToken: !!isDocTokenSession,
      canRunAiInspection,
      userCurrency,
      country,
      driverSide,
    }
  }, [token, temporary, isDocTokenSession, isAutoShare, estimateType])

  return (
    <AuthContext.Provider value={userValues}>
      {canRunAiInspection ? (
        <SocketProvider isLoggedIn={userValues.isLoggedIn} token={token}>
          {children}
        </SocketProvider>
      ) : (
        children
      )}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.any,
}

export function useUser() {
  return useContext(AuthContext)
}
